import io from 'socket.io-client'
import { hostSocket } from '../../configuraciones'

const socket = io.connect(`${hostSocket}`, {
    transports: ['websocket']
})

export default socket